"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconBreadCrumbChevronRight = _interopRequireDefault(require("../Icons/IconBreadCrumbChevronRight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreadCrumbs = function BreadCrumbs(_ref) {
  var urls = _ref.urls;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, urls.length > 3 ? /*#__PURE__*/_react.default.createElement(BreadCrumbsContainer, null, /*#__PURE__*/_react.default.createElement(BreadCrumb, {
    to: urls[0].url
  }, " ", urls[0].label, " "), /*#__PURE__*/_react.default.createElement(StyledChevronRight, null), /*#__PURE__*/_react.default.createElement(BreadCrumbSpacer, null, "..."), /*#__PURE__*/_react.default.createElement(StyledChevronRight, null), /*#__PURE__*/_react.default.createElement(BreadCrumb, {
    to: urls[urls.length - 1].url,
    active: true
  }, urls[urls.length - 1].label)) : /*#__PURE__*/_react.default.createElement(BreadCrumbsContainer, null, urls.map(function (url, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BreadCrumb, {
      to: url.url,
      active: urls.length - 1 !== index ? false : true
    }, url.label), urls.length - 1 !== index ? /*#__PURE__*/_react.default.createElement(StyledChevronRight, null) : '');
  })));
};

var StyledChevronRight = function StyledChevronRight() {
  return /*#__PURE__*/_react.default.createElement(_IconBreadCrumbChevronRight.default, {
    size: 13,
    color: "#8990a3"
  });
};

var BreadCrumbsContainer = _styledComponents.default.div.withConfig({
  displayName: "BreadCrumbsContainer"
})(["display:flex;align-items:center;justify-content:flex-start;font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var BreadCrumb = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "BreadCrumb"
})(["font-size:1.4rem;line-height:2rem;color:", ";margin:0 5px;font-weight:", ";text-decoration:none;transition:color 0.15s ease-in-out;cursor:", ";&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}&:hover{color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.labels.guaranteeText;
}, function (_ref4) {
  var active = _ref4.active;
  return active ? 'bold' : 'normal';
}, function (_ref5) {
  var active = _ref5.active;
  return active ? 'default' : 'pointer';
}, function (_ref6) {
  var theme = _ref6.theme,
      active = _ref6.active;
  return active ? theme.ui.highlight : theme.typo.title;
});

var BreadCrumbSpacer = _styledComponents.default.p.withConfig({
  displayName: "BreadCrumbSpacer"
})(["font-size:1.4rem;line-height:2rem;color:", ";margin:0 5px;text-decoration:none;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.ui.disabled;
});

BreadCrumbs.propTypes = {
  urls: _propTypes.array
};
var _default = BreadCrumbs;
exports.default = _default;